import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getAccountSummaryById } from '../../../core/dapi/account';
import { apiGetDispatchable, apiPatchDispatchableWithoutSource } from '../../../core/dapi';
import { receiveAccountSummary, receiveUserProfileForAccount } from '../../../actions/account';
import { noOp } from '../../../actions';
import { getUserProfileById } from '../../../core/dapi/userProfile';

export default () => {
  const dispatch = useDispatch();

  return useCallback(
    (userProfileId) => {
      const onSuccess = (response: any) => {
        const url = getAccountSummaryById(response.account_id);
        dispatch(apiGetDispatchable(url, receiveAccountSummary, noOp));
        return receiveUserProfileForAccount(response);
      };

      dispatch(
        apiPatchDispatchableWithoutSource(
          getUserProfileById(userProfileId),
          { is_hidden: true },
          onSuccess,
          noOp
        )
      );
    },
    [dispatch]
  );
};
